<sw-card-view>
    <sw-card
        class="frosh-tools-tab-scheduled__tasks-card"
        :title="$t('frosh-tools.tabs.scheduledTaskOverview.title')"
        :isLoading="isLoading"
        :large="true"
        positionIdentifier="frosh-tools-tab-scheduled"
        deprecated
    >
        <template #toolbar>
            <sw-button
                deprecated
                variant="ghost"
                @click="refresh"
            >
                <sw-icon
                    :small="true"
                    name="regular-undo"
                    deprecated
                ></sw-icon>
            </sw-button>
            <sw-button
                deprecated
                variant="primary"
                @click="registerScheduledTasks"
            >
                {{ $t('frosh-tools.scheduledTasksRegisterStarted') }}
            </sw-button>
        </template>

        <template #grid>
            <sw-entity-listing
                :showSelection="false"
                :fullPage="false"
                :allowInlineEdit="true"
                :allowEdit="false"
                :allowDelete="false"
                :showActions="true"
                :repository="scheduledRepository"
                :items="items"
                :columns="columns"
            >
                <template #column-lastExecutionTime="{ item }">
                    {{ date(item.lastExecutionTime, {hour: '2-digit', minute: '2-digit'}) }}
                </template>

                <template
                    #column-nextExecutionTime="{ item, column, compact, isInlineEdit }"
                >
                    <sw-data-grid-inline-edit
                        v-if="isInlineEdit"
                        :column="column"
                        :compact="compact"
                        :value="item[column.property]"
                        @update:value="item[column.property] = $event"
                    >
                    </sw-data-grid-inline-edit>
                    <span v-else>
                        {{ date(item.nextExecutionTime, {hour: '2-digit', minute: '2-digit'}) }}
                    </span>
                </template>

                <template #actions="{ item }">
                    <sw-context-menu-item
                        variant="primary"
                        @click="runTask(item)"
                    >
                        {{ $t('frosh-tools.runManually') }}
                    </sw-context-menu-item>
                    <sw-context-menu-item
                        variant="primary"
                        @click="scheduleTask(item)"
                    >
                        {{ $t('frosh-tools.setToScheduled') }}
                    </sw-context-menu-item>
                    <sw-context-menu-item
                        variant="primary"
                        @click="scheduleTask(item, true)"
                    >
                        {{ $t('frosh-tools.setToScheduledImmediately') }}
                    </sw-context-menu-item>
                    <sw-context-menu-item
                        variant="primary"
                        @click="deactivateTask(item)"
                    >
                        {{ $t('frosh-tools.setToInactive') }}
                    </sw-context-menu-item>
                </template>
            </sw-entity-listing>
        </template>
    </sw-card>
    <sw-modal
        v-if="taskError"
        :title="$t('global.default.error')"
        @modal-close="taskError = null"
    >
        <pre
            v-if="typeof taskError === 'object'"
            v-text="taskError"
        />
        <div
            v-else
            v-html="taskError"
        />
        <template #modal-footer>
            <sw-button
                deprecated
                size="small"
                @click="taskError = null"
            >
                {{ $t('global.default.close') }}
            </sw-button>
        </template>
    </sw-modal>
</sw-card-view>